<template>
  <!-- BEGIN: Dark Mode Switcher-->
  <div
    class="dark-mode-switcher cursor-pointer shadow-md fixed bottom-0 right-0 box dark:bg-dark-2 border rounded-full w-40 h-12 flex items-center justify-center z-50 mb-10 mr-10"
    @click="switchMode"
  >
    <div class="mr-4 text-gray-700 dark:text-gray-300">Modo Oscuro</div>
    <div
      :class="{ 'dark-mode-switcher__toggle--active': darkMode }"
      class="dark-mode-switcher__toggle border"
    ></div>
  </div>
  <!-- END: Dark Mode Switcher-->
</template>

<script>
import { defineComponent, onMounted, computed } from "vue";
import { useStore } from "@/store";
import cash from "cash-dom";

export default defineComponent({
  setup() {
    const store = useStore();
    const darkMode = computed(() => store.state.main.darkMode);

    const setDarkModeClass = () => {
      darkMode.value
        ? cash("html").addClass("dark")
        : cash("html").removeClass("dark");
    };

    const switchMode = () => {
      store.dispatch("main/setDarkMode", !darkMode.value);
      setDarkModeClass();
      _darkThemeSwitch();
    };

    const _addDarkTheme = () => {
      const darkThemeLinkEl = document.createElement('link')
      darkThemeLinkEl.setAttribute('rel', 'stylesheet')
      darkThemeLinkEl.setAttribute('href', 'assets/css/theme-dark.css')
      //darkThemeLinkEl.setAttribute('href', 'https://www.primefaces.org/apollo-vue/assets/theme/theme-blue-dim.css')
      darkThemeLinkEl.setAttribute('id', 'dark-theme-style')
      const docHead = document.querySelector('head')
      docHead.append(darkThemeLinkEl)
    };

    const _removeDarkTheme = () => {
      const darkThemeLinkEl = document.querySelector('#dark-theme-style')
      const parentNode = darkThemeLinkEl.parentNode
      parentNode.removeChild(darkThemeLinkEl)
    };

    const _darkThemeSwitch = () => {
      const darkThemeLinkEl = document.querySelector('#dark-theme-style')
      if (!darkThemeLinkEl) {
        _addDarkTheme()
      } else {
        _removeDarkTheme()
      }
    }

    onMounted(() => {
      setDarkModeClass();
    });

    return {
      switchMode,
      darkMode
    };
  }
});
</script>
